import { render, staticRenderFns } from "./answer-tips.vue?vue&type=template&id=347bd08b&scoped=true&"
import script from "./answer-tips.vue?vue&type=script&lang=js&"
export * from "./answer-tips.vue?vue&type=script&lang=js&"
import style0 from "./answer-tips.vue?vue&type=style&index=0&id=347bd08b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347bd08b",
  null
  
)

export default component.exports